import React from 'react';

import {
  closestCenter,
  DndContext,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  restrictToParentElement,
  restrictToVerticalAxis,
} from '@dnd-kit/modifiers';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import PropTypes from 'prop-types';

import SortableCollectionInput from 'components/collections/SortableCollectionInput';

export default function SortableCollection({
  collection,
  collectionErrors,
  onDelete,
  onListInputChange,
  onSortEnd,
  removeErrorStyling,
}) {
  const sensors = useSensors(useSensor(PointerSensor));

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (active.id !== over.id) {
      onSortEnd({ newIndex: over.id, oldIndex: active.id });
    }
  };

  return (
    <DndContext
      collisionDetection={closestCenter}
      modifiers={[restrictToParentElement, restrictToVerticalAxis]}
      onDragEnd={handleDragEnd}
      sensors={sensors}
    >
      <SortableContext
        items={[...Array(collection.length).keys()]}
        strategy={verticalListSortingStrategy}
      >
        <ul className='sortable-collection'>
          {collection.map((item, index) => (
            <SortableCollectionInput
              collectionErrors={collectionErrors}
              index={index}
              isDeletable={collection.length > 1}
              key={index}
              onChange={onListInputChange}
              onDelete={onDelete}
              removeErrorStyling={removeErrorStyling}
              value={item.name}
            />
          ))}
        </ul>
      </SortableContext>
    </DndContext>
  );
}

SortableCollection.propTypes = {
  collection: PropTypes.array.isRequired,
  collectionErrors: PropTypes.exact({
    errorList: PropTypes.array.isRequired,
    isFallback: PropTypes.bool.isRequired,
  }).isRequired,
  onDelete: PropTypes.func.isRequired,
  onListInputChange: PropTypes.func.isRequired,
  onSortEnd: PropTypes.func.isRequired,
  removeErrorStyling: PropTypes.func.isRequired,
};
